import React from "react"
import { isEqual } from "underscore"
import { TextField } from "@theconversation/ui"

const MemoisedTextField = React.memo(TextField, (prevProps, nextProps) =>
  isEqual(prevProps, nextProps)
)

export default MemoisedTextField
